<template>
  <index-loader></index-loader>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <dashboard-header :title="title" @dateRangeChanged="fetchLeads"/>

          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header border-0 pb-0">
								<div class="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
									<h4><i class="ti ti-grip-vertical me-1"></i>Recently Created Leads</h4>
									<!-- <div class="dropdown">
										<a class="dropdown-toggle" data-bs-toggle="dropdown" href="javascript:void(0);">
											<i class="ti ti-calendar-check me-2"></i>Last 30 days
										</a>
										<div class="dropdown-menu dropdown-menu-end">
											<a href="javascript:void(0);" class="dropdown-item">
												Last 15 days
											</a>
											<a href="javascript:void(0);" class="dropdown-item">
												Last 30 days
											</a>
										</div>
									</div> -->
								</div>
							</div>
                <div class="card-body">
                  <div v-if="Leads_Data.length > 0" class="table-responsive custom-table table-wrapper">
                    <table class="table dataTable" id="lead-project">
                      <thead class="thead-light">
                        <tr>
                          <th>Lead ID</th>
                          <th>Organization Name</th>
                          <th>Lead Stage</th>
                          <th>Lead Priority</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in Leads_Data" :key="item.id">
                          <td>{{ item.LeadID }}</td>
                          <td>
                            {{ truncateText(item.CompanyName, 15) }}
                          </td>
                          <td>{{ item.lead_stage }}</td>
                          <td>
                            <span :class="item.Class">{{ item.lead_priority }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <p v-else class="text-center text-muted">No leads found for the selected date range.</p>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/utils/http";
import Leads_Dashboard from "@/assets/json/leads-dashboard.json";
import { contactReportChart, leadLastChart, leadWonCharts } from "./data";
import Chart from 'chart.js/auto';

export default {
  data() {
    return {
      title: "Prospect Dashboard",
      Leads_Dashboard: Leads_Dashboard,
      // leadpieChart: leadpieChart,
      contactReportChart: contactReportChart,
      leadLastChart: leadLastChart,
      leadWonCharts: leadWonCharts,

      Leads_Data: [],
      pieChartInstance: null,
    };
  },
  mounted() {
    // this.fetchLeads();
  },
  computed: {
    chartHasData() {
      return this.Leads_Data && this.Leads_Data.length > 0;
    },
  },
  methods: {
    async fetchLeads(startDate = null, endDate = null) {
      try {
        const params = {};
        if (startDate && endDate) {
          params.start_date = startDate;
          params.end_date = endDate;
        }

        const response = await http.get("leads-dashboard-data", { params });
        this.Leads_Data = response.data.contents.leads;

        const labels = response.data.contents.chartData.labels; // Lead stages
        const data = response.data.contents.chartData.series;  // Counts
        
        this.$nextTick(() => {
          this.initializePieChart(labels, data);
        });
      } catch (error) {
        console.error("Error:", error);
      } finally {
        this.isLoading = false;
      }
    },

    truncateText(text, length) {
      if (!text) return "";
      return text.length > length ? text.slice(0, length) + "..." : text;
    },

    initializePieChart(labels, data) {
      const chartCanvas = document.getElementById("leadStagePieChart");
      if (!chartCanvas) {
        console.error("Canvas element not found for Pie Chart.");
        return;
      }

      const ctx = chartCanvas.getContext('2d');
      if (this.pieChartInstance) {
        this.pieChartInstance.destroy();
      }
      
      this.pieChartInstance = new Chart(ctx, {
        type: 'pie',
        data: {
          labels: labels,
          datasets: [{
            label: 'Lead Stages',
            data: data,
            backgroundColor: [
              '#f39c12', '#00a65a', '#f56954', '#00c0ef', '#3c8dbc', '#d2d6de', '#9b59b6'
            ],
            borderWidth: 1,
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'top',
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const label = context.label || '';
                  const value = context.raw || 0;
                  return `${label}: ${value}`;
                }
              }
            }
          }
        }
      });
    },
  },
};
</script>

<style>
.table-wrapper {
  max-height: 400px; /* Adjust the height based on your preference */
  overflow-y: auto;
}

.table th {
  position: sticky;
  top: 0;
  background-color: #fff; /* Optional: Add a background to the header to make it stand out */
  z-index: 10; /* Ensure the header stays on top of table rows */
}
</style>